import { Menu, MenuItem, MenuItemProps, MenuProps, Stack } from "@mui/material";
import { useBorder } from "@pulse/shared-components";
import {
  Button,
  ButtonProps,
  useSpacing,
} from "@surya-digital/leo-reactjs-material-ui";
import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useRef, useState } from "react";

interface MenuButtonProps {
  button: Omit<ButtonProps, "onClick">;
  menu?: Omit<MenuProps, "open" | "slotProps">;
  menuItems: MenuItemProps[];
}

export const MenuButton: React.FC<MenuButtonProps> = ({
  button,
  menu = {},
  menuItems,
}) => {
  const { onClose, ...menuProps } = menu;

  const [openMenu, setOpenMenu] = useState(false);

  const border = useBorder();
  const spacing = useSpacing();
  const buttonRef = useRef<HTMLDivElement>(null);

  return (
    <Stack>
      <div ref={buttonRef}>
        <Button
          icon={button.icon ?? (openMenu ? <ChevronUp /> : <ChevronDown />)}
          onClick={() => setOpenMenu(true)}
          iconPosition="trailing"
          {...button}
        />
      </div>
      <Menu
        open={openMenu}
        onClose={(...params) => {
          setOpenMenu(false);
          onClose?.(...params);
        }}
        anchorEl={buttonRef.current}
        slotProps={{
          paper: {
            sx: {
              border: border.subtle,
              minWidth: buttonRef.current?.offsetWidth ?? 0,
            },
          },
        }}
        {...menuProps}
      >
        {menuItems.map(({ onClick, sx, ...menuItemProps }, index) => (
          <MenuItem
            key={index}
            onClick={(...params) => {
              setOpenMenu(false);
              onClick?.(...params);
            }}
            sx={{
              paddingBlock: spacing.spaceSM,
              paddingInline: spacing.spaceMD,
              ...sx,
            }}
            {...menuItemProps}
          />
        ))}
      </Menu>
    </Stack>
  );
};
